
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface FormActionsProps {
  isSubmitting: boolean;
  isEditMode?: boolean;
  cancelPath?: string;
  hideSubmitButton?: boolean;
}

const FormActions = ({ 
  isSubmitting, 
  isEditMode = false, 
  cancelPath = "/agents",
  hideSubmitButton = false 
}: FormActionsProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex justify-end gap-4">
      <Button 
        type="button" 
        variant="outline" 
        onClick={() => navigate(cancelPath)}
        disabled={isSubmitting}
      >
        Cancel
      </Button>
      
      {!hideSubmitButton && (
        <Button type="submit" disabled={isSubmitting}>
          {isSubmitting ? (
            <span className="flex items-center gap-1">
              <span className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
              Saving...
            </span>
          ) : (
            <span>{isEditMode ? "Update Agent" : "Create Agent"}</span>
          )}
        </Button>
      )}
    </div>
  );
};

export default FormActions;
